import React, {useState, useEffect} from 'react'
import FormBuilder from '../../components/FormBuilder'
import {Button, FormHelperText, Grid, Typography} from '@material-ui/core/'
import {useFormReducerHook} from '../../utils/customHooks'
import {Link, Redirect} from 'react-router-dom'
import {useSettings} from '../../utils/Settings'
import Loader from '../../components/Loader'
import ArrowBack from '@material-ui/icons/ArrowBack'
import {
    getEncryptedVersion,
    authenticationApi,
    getOuterAuthenticate,
} from '../../services/outReach'
import MarkDownRenderer from '../../components/MarkdownRender'
import ReactMarkdown from 'react-markdown'
import queryString from 'query-string'
import rehypeRaw from 'rehype-raw'
const Login = props => {
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
        updateEntireFormData,
    } = useFormReducerHook()

    const {logged, login, appConfig} = useSettings()
    const [loading, setloading] = useState(false)

    const [isDashboard, setIsDashboard] = useState(false)
    const [checkAuthMethod, setCheckAuthMethod] = useState(false)
    const [loginError, setLoginError] = useState('')

    const queryParam = queryString.parse(props.location.search)

    const submit = () => {
        setLoginError('')
        if (validate()) {
            setloading(true)
            window.sessionStorage.clear()
            setTimeout(async () => {
                const encryptedPassword = getEncryptedVersion(formData.password)
                let input = {
                    loginname: formData.username.trim(),
                    password: encryptedPassword,
                }
                if (queryParam['open-on-section'])
                    input['openonsection'] = queryParam['open-on-section']

                const result = await authenticationApi(input)
                if (Object.entries(result.error).length > 0) {
                    setloading(false)
                    setLoginError(result.error.message)
                } else {
                    if (result.success.cliententityid) {
                        const key = sessionStorage.getItem('sessionClientEntityId')
                        if (!key) {
                            sessionStorage.setItem(
                                'sessionClientEntityId',
                                String(result.success.cliententityid)
                            )
                        }
                    }
                    if (queryParam['open-on-section']) {
                        sessionStorage.setItem(
                            'openOnSection',
                            String(queryParam['open-on-section'])
                        )
                    }
                    if (result.success.url) {
                        window.location.assign(result.success.url)
                    } else login()
                }
            }, 500)
        }
    }

    const actionMethods = (type, payload) => {
        switch (type) {
            case 'enterOnKeyUp':
                submit()
                break
            default:
                break
        }
    }
    useEffect(() => {
        document.title = appConfig.pageTitle.login
    }, [appConfig.pageTitle.login])

    useEffect(() => {
        const callAPI = async () => {
            const result = await getOuterAuthenticate()
            if (result.success.url) {
                window.location.assign(result.success.url)
            }
        }
        if (appConfig.outsideAuthentication) callAPI()
        if (appConfig.checkAuthMode) {
            if (window.history.state && window.history.state.state) {
                updateEntireFormData(window.history.state.state)
                window.history.replaceState(undefined, 'state')
            } else setCheckAuthMethod(true)
        }
    }, [appConfig.outsideAuthentication])

    if (isDashboard) return <Redirect to="/dashboard" />

    if (logged) return <Redirect to="/onboard/welcome" />

    if (checkAuthMethod) return <Redirect to="/signin" />
    if (appConfig.outsideAuthentication)
        return (
            <React.Fragment>
                {appConfig.supportedLabels.login.SAMLEnabledLoadingMessage}
                <Loader type="page" />
            </React.Fragment>
        )
    return (
        <Grid item className="login__contanier">
            <Grid item className="login__signin">
                <Grid item className="login__head">
                    <Typography variant="h3" className="login__title" component="h2">
                        {appConfig.checkAuthMode && (
                            <Link to="/signin" style={{textDecoration: 'none'}}>
                                <ArrowBack name="arrow left" size="large" />{' '}
                            </Link>
                        )}
                        {appConfig.supportedLabels.login.loginHeader}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container className="login__form">
                <FormBuilder
                    fields={appConfig.loginFormProps}
                    formData={formData}
                    setFormData={setFormData}
                    errorsData={errorsData}
                    updateValidation={updateValidationData}
                    actionMethods={actionMethods}
                />
                {appConfig.customization.forgotPasswordLink && (
                    <Grid item xs className="login__form-sub">
                        <Grid item xs className="login__form-sub--forgotPassword">
                            <Link to="/forgotpassword">
                                <Button color="primary">
                                    {appConfig.supportedLabels.login.forgotPasswordBtnTxt}
                                </Button>
                            </Link>
                        </Grid>
                    </Grid>
                )}
                <Grid xs={12}>
                    <FormHelperText error>
                        <FormHelperText error="true">
                            <ReactMarkdown children={loginError} rehypePlugins={[rehypeRaw]} />
                        </FormHelperText>
                    </FormHelperText>
                </Grid>
                <Grid item xs className="login__form-action">
                    <Grid item xs={12} className="loader__container">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                submit()
                            }}
                            disabled={loading}
                        >
                            {appConfig.supportedLabels.login.loginBtnTxt}
                        </Button>

                        {loading ? <Loader /> : null}
                    </Grid>

                    {appConfig.customization.registrationLink && (
                        <Grid item xs className="login__form-bottom-action">
                            {appConfig.supportedLabels.login.newUserTxt}{' '}
                            <Link to="/">
                                <Button color="primary">
                                    {appConfig.supportedLabels.login.signupBtnTxt}
                                </Button>
                            </Link>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Login
